import React from 'react';
import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { Sidebar } from './Sidebar';

interface StoreFilterProps {
  onClose: () => void;
  stores: Record<string, any>;
  runFilter: () => void;
  selectedStores: string[];
  onChange: (stores: string[]) => void;
}

export const StoreFilter: React.FC<StoreFilterProps> = ({
  onClose,
  stores,
  runFilter,
  selectedStores,
  onChange
}) => {
  const storesToDisplay = Object.keys(stores);

  const onChangeStoreCheckbox = (store: string, val: boolean) => {
    let newStoresList = [...selectedStores];
    if (val) {
      newStoresList.push(store);
    } else {
      const delIndex = newStoresList.findIndex(b => b === store);
      newStoresList.splice(delIndex, 1);
    }
    onChange(newStoresList);
  };

  return (
    <Sidebar title="Store Filter" onClose={onClose} showDoneButton={false}>
      <div style={{ padding: 24, height: '85%', overflowY: 'auto' }}>
        <FormGroup>
          {storesToDisplay.map(store => {
            const isSelected = selectedStores.includes(store);
            return (
              <FormControlLabel
                key={store}
                control={<Checkbox />}
                checked={isSelected}
                onChange={(_evt, val) => {
                  onChangeStoreCheckbox(store, val);
                }}
                label={store}
              />
            );
          })}
        </FormGroup>
      </div>
    </Sidebar>
  );
};
